import React from "react";
import SummaryCard from "../components/SummaryCard";
import CategoryChart from "../components/CategoryChart";
import TransactionList from "../components/TransactionList";

const Dashboard = ({ totals, transactions, deleteTransaction, categoryData, openModal }) => {
  return (
    <>
      <div className="summary-row">
        <SummaryCard title="Total Income" amount={totals.income} icon="📈" color="green" />
        <SummaryCard title="Total Expenses" amount={totals.expenses} icon="📉" color="red" />
        <SummaryCard title="Balance" amount={totals.balance} icon="💰" color="blue" />
      </div>

      <div className="grid-2">
        <CategoryChart data={categoryData} />
        <TransactionList transactions={transactions} onDelete={deleteTransaction} />
      </div>

      <div className="add-cta">
        <button className="btn primary" onClick={openModal}>Add Transaction</button>
      </div>
    </>
  );
};

export default Dashboard;
